import { render, staticRenderFns } from "./ExpenseTypeBasicForm.vue?vue&type=template&id=6df3dba8"
import script from "./ExpenseTypeBasicForm.vue?vue&type=script&lang=js"
export * from "./ExpenseTypeBasicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports